module.exports = __webpack_public_path__ + "static/media/menu.b50b4b90.svg";